import { render, staticRenderFns } from "./ProfileEditForm.vue?vue&type=template&id=01b2d604&scoped=true&"
import script from "./ProfileEditForm.vue?vue&type=script&lang=js&"
export * from "./ProfileEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditForm.vue?vue&type=style&index=0&id=01b2d604&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b2d604",
  null
  
)

/* custom blocks */
import block0 from "./ProfileEditForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports